import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import classNames from 'classnames';
import { Dropdown } from 'carbon-components-react';
import { FW_PREFIX } from '../../../shared/constants/generalConstants.js';

var BASE_CSS = "".concat(FW_PREFIX, "__IlDropdown");
var IlDropdown = /*#__PURE__*/function (_Component) {
  function IlDropdown() {
    _classCallCheck(this, IlDropdown);
    return _callSuper(this, IlDropdown, arguments);
  }
  _inherits(IlDropdown, _Component);
  return _createClass(IlDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        invalid = _this$props.invalid,
        id = _this$props.id,
        type = _this$props.type;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, BASE_CSS, _defineProperty({}, "".concat(BASE_CSS, "--").concat(type), type), _defineProperty({}, "".concat(BASE_CSS, "--invalid"), invalid))
      }, /*#__PURE__*/React__default.createElement(Dropdown, _extends({}, this.props, {
        role: "listbox",
        tabIndex: -1,
        "aria-labelledby": id
      })));
    }
  }]);
}(Component);
_defineProperty(IlDropdown, "propTypes", Dropdown.propTypes);
_defineProperty(IlDropdown, "defaultProps", {
  size: 'xl'
});

export { IlDropdown };
